var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.395264,
    width: 32,
    height: 32,
    rx: 8,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9376 8.75719C15.4821 7.7476 16.8433 7.7476 17.3878 8.75719L24.7385 22.3866C25.283 23.3962 24.6024 24.6582 23.5134 24.6582H8.81202C7.72302 24.6582 7.0424 23.3962 7.5869 22.3866L14.9376 8.75719Z",
    fill: "#FF5D5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7553 14.1714C15.6386 14.2811 15.573 14.4299 15.573 14.5851V18.3463C15.573 18.5014 15.6386 18.6503 15.7553 18.76C15.872 18.8697 16.0302 18.9313 16.1953 18.9313C16.3603 18.9313 16.5186 18.8697 16.6352 18.76C16.7519 18.6503 16.8175 18.5014 16.8175 18.3463V14.5851C16.8175 14.4299 16.7519 14.2811 16.6352 14.1714C16.5186 14.0616 16.3603 14 16.1953 14C16.0302 14 15.872 14.0616 15.7553 14.1714Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7508 20.8732C15.8824 20.9559 16.037 21 16.1953 21C16.3003 21 16.4044 20.9805 16.5014 20.9427C16.5985 20.9049 16.6867 20.8495 16.7609 20.7797C16.8352 20.7098 16.8942 20.6269 16.9344 20.5356C16.9746 20.4444 16.9953 20.3465 16.9953 20.2478C16.9953 20.099 16.9483 19.9535 16.8604 19.8298C16.7725 19.7061 16.6476 19.6097 16.5014 19.5528C16.3552 19.4958 16.1944 19.481 16.0392 19.51C15.884 19.539 15.7415 19.6106 15.6296 19.7158C15.5177 19.8211 15.4415 19.9551 15.4106 20.101C15.3798 20.2469 15.3956 20.3982 15.4562 20.5356C15.5167 20.6731 15.6192 20.7906 15.7508 20.8732Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarn);
export default __webpack_public_path__ + "static/media/icon-warn.48d18ff9d0aa4b3dfaac97dfecc3322a.svg";
export { ForwardRef as ReactComponent };